export const CLEAR_RESERVATION = 'CLEAR_RESERVATION';
